module.exports = __webpack_public_path__ + "img/advisory_core_select01.655bf6aa.png";